import { InjectionToken, Signal, signal } from '@angular/core';

/** Provided by components that render their DOM into an image (PDF/PNG export): while true, pictures outside the viewport load too. */
export const EAGER_EMPLOYEE_PICTURES = new InjectionToken<Signal<boolean>>('EAGER_EMPLOYEE_PICTURES', {
  factory: () => signal(false)
});
